import type { InvoiceStatus as InvoiceStatusType } from '@cocoonspace/sdk-js/types/invoiceStatus'
import { Check, Hourglass, TriangleAlert, X } from 'lucide-react'
import { useTranslation } from 'next-i18next'
import { cn } from '~/lib/utils'

export const InvoiceStatus = ({
	status,
	className,
}: {
	status: InvoiceStatusType
	className?: string
}) => {
	const { t } = useTranslation()

	return (
		<div
			className={cn(
				'flex items-end gap-x-1 leading-none lg:items-center lg:gap-x-2 lg:px-4',
				className,
			)}
		>
			{status === 'late' && <Hourglass className='size-4 text-primary' />}
			{status === 'open' && <TriangleAlert className='size-4 text-warning' />}
			{status === 'paid' && <Check className='size-4 text-emerald-400' />}
			{status === 'voided' && <X className='size-4 text-primary' />}

			{t(`myAccountInvoices:list.status.${status}`)}
		</div>
	)
}
